import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import cyclingBuddyLogo from '../../assets/cyclingbuddy_logo.png';
import UserMenu from '../auth/UserMenu';
import './Header.css';

const Header: React.FC = () => {
  // Always render the same header - just logo and title
  return (
    <AppBar position="static" className="header-appbar">
      <Toolbar variant="dense" className="header-toolbar">
        <Link 
          to="/" 
          className="header-link"
          style={{ 
            WebkitTapHighlightColor: 'transparent',
            backgroundColor: 'transparent',
            transition: 'none',
            color: 'inherit'
          }}
          onTouchStart={(e) => {
            // Prevent any default touch behavior that might cause color change
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
          onTouchEnd={(e) => {
            // Ensure background stays transparent after touch
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          <img 
            src={cyclingBuddyLogo} 
            alt="Cycling Buddy Logo" 
            className="header-logo"
          />
          <Typography
            variant="h6"
            component="div"
            className="header-title"
          >
            Cycling Buddy
          </Typography>
        </Link>
        <Box sx={{ flexGrow: 1 }} />
        <UserMenu />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
